module.exports = __webpack_public_path__ + "static/media/dashboard-spend.3560134f.png";